// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"39":"358a6e96","121":"cd694780","136":"61a73e04","329":"1c3d189c","394":"61c4776a","495":"3c656849","656":"195d69cf","791":"9ce8349b"}[chunkId] + ".js";
};